import React from 'react';
import InteractiveGuide from './InteractiveGuide';

const AdminUserGuide = ({ t }) => {
  return (
    <div className="max-w-[1600px] mx-auto py-4 px-4 sm:px-6">
      <InteractiveGuide t={t} />
    </div>
  );
};

export default AdminUserGuide;
